import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate(['LOAD_SETTINGS']);
